module.exports = __webpack_public_path__ + "img/meishuguan.4b80296d.jpg";